// extracted by mini-css-extract-plugin
export default {"login-view":"index_login-view__NLFY4"};